import { UnitsDto } from "app/modules/dashboard/modules/material-management/unit/model/units.dto";
import { UnitSetUnitsDto } from "@dashboard/modules/material-management/unit-set/model/unit-set-units.dto";

export class UnitSetDto {
  public id?: number;
  public code?: string;
  public master_unit?: UnitsDto;
  public description?: string;
  public unit_set_units?: Array<UnitSetUnitsDto>;
}
